import { Badge } from 'twyne-new.ui';

import { getInfo } from '@Components/Grid/components/Table/formatters';

import { TYPES_MAPPING } from './DetailsFormatter'

export default function MultiBuyerFormatter({ info }) {
  const { row: { integrationDataParsed, type } } = getInfo(info)
  const { integrationId } = integrationDataParsed?.[TYPES_MAPPING[type]] || {}

  const config = {
    active: {
      label: 'active',
      color: 'accent',
    },
    inactive: {
      label: 'inactive',
      color: 'danger',
    },
  }

  const status = integrationId ? config.active : config.inactive

  return <Badge variant='outline' color={status.color}>
    {status.label}
  </Badge>
}
